import {ITheme} from 'contexts/ThemeContext';
import {Platform} from 'react-native';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  minSize,
} from 'rn-responsive-styles';

export default ({colors, typography}: ITheme) =>
  CreateResponsiveStyle(
    {
      containerStyle: {
        alignItems: 'center',
      },
      pickerContainerStyle: {
        marginBottom: 20,
      },
      calendarStyle: {
        justifyContent: 'center',
      },
      webTitleStyle: {
        marginBottom: 28,
        fontSize: 28,
        lineHeight: 46,
        ...typography.mulishBold,
      },
      zIndex7: {
        zIndex: 7,
      },
      zIndex6: {
        zIndex: 6,
      },
      zIndex5: {
        zIndex: 5,
      },
      zIndex4: {
        zIndex: 4,
      },
      zIndex3: {
        zIndex: 3,
      },
      zIndex2: {
        zIndex: 2,
      },
      dropDownListStyle: {
        position: 'absolute',
        top: 50,
        width: 248,
        maxHeight: 192,
        backgroundColor: colors.white,
        borderWidth: 1,
        borderColor: colors.grey300,
        borderRadius: 8,
      },
      containerButtonStyle: {
        width: '100%',
      },
      ...Platform.select({
        web: {
          containerButtonStyle: {
            marginTop: 50,
            width: '100%',
          },
          createButtonStyle: {},
          cancelButtonStyle: {
            backgroundColor: colors.purple(0.13),
          },
          cancelTitleButtonStyle: {
            color: colors.cornflowerBlue,
          },
        },
      }),
    },
    {
      [minSize(DEVICE_SIZES.SMALL_DEVICE)]: {
        containerStyle: {
          alignItems: 'flex-start',
          padding: 30,
          backgroundColor: colors.white,
          borderWidth: 1,
          borderRadius: 20,
          borderColor: colors.grey300,
        },
        webTitleStyle: {
          alignSelf: 'flex-start',
        },
        pickerContainerStyle: {
          marginBottom: 40,
        },
        containerButtonStyle: {
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: 110,
          width: 420,
        },
        createButtonStyle: {
          width: 200,
          marginBottom: 0,
        },
        cancelButtonStyle: {
          width: 200,
          marginBottom: 0,
        },
        cancelTitleButtonStyle: {},
      },
      [minSize(DEVICE_SIZES.MEDIUM_DEVICE)]: {
        containerStyle: {
          alignItems: 'flex-start',
          padding: 30,
          backgroundColor: colors.white,
          borderWidth: 1,
          borderRadius: 20,
          borderColor: colors.grey300,
        },
        webTitleStyle: {
          alignSelf: 'flex-start',
        },
        pickerContainerStyle: {
          marginBottom: 40,
        },
        containerButtonStyle: {
          width: 641,
        },
        createButtonStyle: {
          width: 308,
        },
        cancelButtonStyle: {
          width: 308,
        },
        cancelTitleButtonStyle: {},
      },
    },
  )();
